module.exports = __webpack_public_path__ + "static/img/taxcellent_oversea_bg_h5.1312cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxcellent_oversea_bg_h5.png
// module id = 6hj/
// module chunks = 34